type CodedError = { error?: string; message?: string };

export function parseAlertErrorCode(err: unknown): CodedError {
  const data = (err as any)?.data;
  const candidate =
    typeof data === 'string'
      ? data
      : typeof data?.message === 'string'
        ? data.message
        : null;
  if (!candidate) return {};
  try {
    const parsed = JSON.parse(candidate);
    if (parsed && typeof parsed === 'object') return parsed as CodedError;
  } catch {
    return {};
  }
  return {};
}

export function isPhoneNotVerifiedError(err: unknown): boolean {
  return (
    (err as any)?.status === 403 &&
    parseAlertErrorCode(err).error === 'PHONE_NOT_VERIFIED'
  );
}

export function isFeatureNotAvailableError(err: unknown): boolean {
  return (
    (err as any)?.status === 403 &&
    parseAlertErrorCode(err).error === 'FEATURE_NOT_AVAILABLE'
  );
}
